<template>
  <s-task-list-layout
    :title="title"
    :signbasket="isShowSignBasket"
    :history-u-r-l="isESign ? `/tasklist/eSignGroupListHistory/${currGroupId?currGroupId:''}` : `/tasklist/outboxGroupListHistory/${currGroupId?currGroupId:''}`"
    @searchIconClick="onServerSearchIconClick"
  >
    <template v-slot:toolbarExtension>
      <s-group-selector
        ref="groupSelector"
        :key="sGroupSelectorKey"
        :business-code="businessCode"
        :curr-group-id.sync="currGroupId"
      />
    </template>

    <template v-slot:search-area>
      <!--
      <s-filter-box
        ref="filterBox"
        :issue-entities-with-all="issueEntitiesWithAll"
        @filterChange="filterTaskList"
      />
      -->
      <s-server-filter-box
        ref="filterBox"
        @search="search"
      />
    </template>
    <v-skeleton-loader
      v-if="loading"
      type="list-item-avatar-two-line, divider, list-item-avatar-two-line"
    />

    <div v-show="!loading">
      <s-class-pdf-muti
        v-model="dialog"
        :file-ctxs="files"
      />
      <v-sheet
        v-for="(task, i) in taskList"
        :key="task.id"
        color="white"
        class="mb-4"
        style="position: relative;"
      >
        <div class="px-4 py-3">
          <v-chip
            v-if="task.isRolledback"
            class="mr-2"
            outlined
            color="red"
          >
            {{ $t('TaskList.Rollback.SystemMessage') }}
          </v-chip>
          <h3>{{ $chPtObjData('chinTaskListTitle', task.formAttribute) }}</h3>
          <!-- <v-btn
              icon
              large
              class="float-right"
              @click="previewOficioFileList(task)"
            >
              <v-icon color="deep-orange lighten-2">
                mdi-file-document
              </v-icon>
            </v-btn> -->
          <s-flow-view-doc-btn
            :has-ref-file="task.formAttribute.referenceDocumentList.length > 0"
            @previewOficioFile="previewOficioFileList(task)"
            @previewRefFile="previewRefFileList(task)"
          />
          {{ $chPtObjData('chinTaskListDesc1', task.formAttribute) }}<br>
          {{ $chPtObjData('chinTaskListDesc2', task.formAttribute) }}<br>

          <!-- <v-btn
                style="float: right;"
                @click="previewRefFileList(task)"
              >
                查閱參考文件
              </v-btn>
              <v-btn
                style="float: right; margin-right: 20px;"
                @click="previewOficioFileList(task)"
              >
                查閱上呈文件
              </v-btn> -->

          <!-- <div>{{ $chPtObjData('chinTaskListDesc1', task.formAttribute) }}</div> -->
          <div
            v-if="!isESign && entityAdministrativeSupportRelation.length > 0"
            class="text-body-2"
          >
            {{ $t('Outbox.IssueDept') }}: {{ $chPtObjData('issueEntityChinName', taskListProps[i]) }}
          </div>
          <div v-if="!isESign && taskListProps[i].receiveEntities.length > 0">
            <div class="text-body-2 grey--text">
              {{ $t('Outbox.ReceiveDept') }} ({{ taskListProps[i].receiveEntities.length }}{{ $t('Outbox.Count') }})
            </div>
            <div class="text-body-2">
              <span
                v-for="(entity,k) in taskListProps[i].receiveEntities.slice(0, 3)"
                :key="k"
                class="entity-list-item"
              >
                {{ $chPtObjData('chinName', entity) }}
                <template v-if="k !== taskListProps[i].receiveEntities.slice(0, 3).length - 1">
                  ,
                </template>
              </span>

              <template v-if="taskListProps[i].receiveEntities.length > 3">
                ...
                <s-flow-all-entities
                  :title="$t('Outbox.ReceiveDept')"
                  :entities="taskListProps[i].receiveEntities"
                />
              </template>
            </div>
          </div>

          <div v-if="!isESign && taskListProps[i].ccEntities.length > 0">
            <div class="text-body-2 grey--text">
              {{ $t('Outbox.CCDept') }} ({{ taskListProps[i].ccEntities.length }}{{ $t('Outbox.Count') }} - <span v-if="taskListProps[i].isCarbonCopyAttachments">{{ $t('Outbox.CCWithAttachment') }}</span><span v-else>{{ $t('Outbox.CCWithoutAttachment') }}</span>)
            </div>
            <div class="text-body-2">
              <span
                v-for="(entity,k) in taskListProps[i].ccEntities.slice(0, 3)"
                :key="k"
                class="entity-list-item"
              >
                {{ $chPtObjData('chinName', entity) }}
                <template v-if="k !== taskListProps[i].ccEntities.slice(0, 3).length - 1">
                  ,
                </template>
              </span>

              <template v-if="taskListProps[i].ccEntities.length > 3">
                ...
                <s-flow-all-entities
                  :entities="taskListProps[i].ccEntities"
                  :title="$t('Outbox.CCDept')"
                />
              </template>
            </div>
          </div>
          <!-- <v-btn
                icon
                @click="taskListProps[i].show = !taskListProps[i].show"
              >
                <v-icon>{{ taskListProps[i].show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn> -->

          <div
            v-if="task.formMessage && task.formMessage.privateMessage"
            class="pa-3 grey lighten-4"
          >
            {{ $chPtObjData('chinPrivateMessageFrom',task.formMessage) }} <v-icon>{{ mdiRedo }}</v-icon>: {{ task.formMessage.privateMessage }}
            <template>
              <span class="grey--text text-caption">({{ momentWithHyphen(task.formMessage.createdTime).format('YYYY-MM-DD HH:mm') }})</span>
            </template>
          </div>

          <br>

          <p class="text-body-2">
            {{ $t('Outbox.PreviousHandler') }}: {{ $chPtObjData('chinStaffName', task.workItemHistoryList[0]) }} - {{ task.workItemHistoryList[0].message }}
            <s-flow-history
              :work-item="task"
              :text="'('+$t('TaskList.Detail')+')'"
            />
          </p>
          <!-- <s-flow-history :history-list="fakeHistory" /> -->
          <v-tooltip
            v-if="$config.isShowEncrypted && taskListProps[i].isEncryptedDoc"
            top
            color="black"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                outlined
                :color="taskListProps[i].securityLevelId > 2 ? 'purple' : 'info'"
                v-bind="attrs"
                v-on="on"
              >
                {{ getSecurityLevel(taskListProps[i]) }}
              </v-chip>
            </template>
            <span>
              {{ getSecurityLevel(taskListProps[i]) }}
            </span>
          </v-tooltip>
          <s-add-encrypted-staff-pop-up
            v-if="$config.isShowEncrypted && $config.isEncryptDynamicFlow && taskListProps[i].isMeOpener"
            :task="task"
            :task-list-props="taskListProps[i]"
            @submitSuccess="refreshTaskList(task.assignedToEuid, task.formAttribute.businessCode)"
          />
          <br>
          <template v-if="taskListProps[i].editMode === false">
            <v-chip
              v-if="taskListProps[i].isDirectSendToEDocX"
              class="ma-2 ml-0"
              outlined
              color="red"
            >
              {{ $t('Outbox.DirectSendAfterSign') }}
            </v-chip>
            <v-chip
              v-if="taskListProps[i].isUrgent"
              class="ma-2 ml-0"
              outlined
              color="red"
            >
              {{ $t('Outbox.Urgent') }}
            </v-chip>
          </template>
          <template v-else>
            <v-switch
              v-if="!isESign"
              v-model="taskListProps[i].isDirectSendToEDocX"
              :label="$t('Outbox.DirectSendAfterSign')"
              hide-details
              class="d-inline-block mr-6"
            />
            <v-switch
              v-if="!isESign"
              v-model="taskListProps[i].isUrgent"
              :label="$t('Outbox.Urgent')"
              hide-details
              class="d-inline-block"
            />
          </template>

          <v-text-field
            v-if="!task.isFinalStep"
            v-model="task.opinion"
            :label="$t('TaskList.Opinion')"
            hide-details
            :disabled="isApprove(task.status)"
          />
          <template
            v-if="!task.isFinalStep"
          >
            <s-search-staff
              show-support-staff
              show-group
              :select.sync="task.defaultNextEuid"
              :staff.sync="task.nextStaffObj"
              :label="$t('Outbox.NextStaff')"
            />
          </template>

          <br>

          <div class="d-flex mt-4">
            <v-btn
              v-if="taskListProps[i].editMode === false"
              icon
              color="black"
              @click="taskListProps[i].editMode = true"
            >
              <v-icon>{{ mdiSquareEditOutline }}</v-icon>
            </v-btn>
            <s-upload-modal
              v-else
              :task="task"
              :business-code="businessCode"
              @updateSuccess="onUpdateOficioSuccess"
            />
            <v-spacer />
            <!-- 退回上一位 -->
            <!-- <s-rollback-task
              :task="task"
              :require-message="requireMessage"
              @rollback-task="rollbackTask(task)"
            /> -->
            <v-tooltip
              color="black"
              top
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="task.isFinalStep"
                  icon
                  color="primary"
                  class="mr-2"
                  :outlined="task.isAddedToSigningCart"
                  :loading="esignAddLoading[task.id]"
                  v-on="on"
                  @click="addToSigningCart(task, staff, genFormMeta(task, taskListProps[i]))"
                >
                  <v-icon>
                    {{ mdiCheck }}
                  </v-icon>
                </v-btn>
                <v-btn
                  v-if="!task.isFinalStep"
                  icon
                  color="primary"
                  class="mr-2"
                  v-on="on"
                  @click="askWhetherAgreeTask(task, taskListProps[i])"
                >
                  <v-icon>
                    {{ mdiCheck }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('TrainingClient.TaskList.Personal1.Agree') }}</span>
            </v-tooltip>

            <!-- 轉交-->
            <s-transfer-task
              css-class="mr-2"
              :task="task"
              :require-message="requireMessage"
              :curr-group-id="currGroupId"
              @transfer-task="transferTaskToStaff(task, $event, taskListProps[i])"
            />

            <v-tooltip
              color="black"
              top
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  :disabled="task.isAddedToSigningCart"
                  color="error"
                  v-on="on"
                  @click="askWhetherCancelTask(task, taskListProps[i])"
                >
                  <v-icon>
                    {{ mdiClose }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Text.Cancel') }}</span>
            </v-tooltip>
          </div>

          <v-overlay
            absolute
            opacity=".25"
            color="black"
            :value="task.isAddedToSigningCart"
          >
            <v-sheet
              class="pa-4 text-h5 text-center text--primary elevation-4"
              color="white"
              min-width="300"
            >
              {{ $t('TaskList.AddedToSignBasket') }}
              <v-icon class="success--text text-h4">
                {{ mdiCheck }}
              </v-icon>
              <br><br>
              <v-btn
                light
                depressed
                primary
                :loading="esignRemoveLoading"
                @click="removeSigningFromCart(task)"
              >
                {{ $t('TaskList.RemoveFromSignBasket') }}
              </v-btn>
            </v-sheet>
          </v-overlay>
        </div>
      </v-sheet>

      <s-prompt-dialog
        v-model="isShowCancelTaskDialog"
        :title="$t('TaskList.AttentionManagement.CancelConfirmation')"
        :field-label="$t('TaskList.CancelReason')"
        :message.sync="cancelReason"
        @confirm="confirmDelete"
      />

      <s-confirm-dialog
        v-model="isShowAgreeTaskDialog"
        :message="$t('TaskList.AttentionManagement.AgreeConfirmation')"
        @confirm="confirmAgree"
      />

      <template v-if="taskList.length === 0">
        <v-sheet>
          <div class="px-4 py-3">
            {{ $t('PublicServant.NoData') }}
          </div>
        </v-sheet>
      </template>

      <div>
        <v-pagination
          v-if="totalPage"
          v-model="page"
          :length="totalPage"
          circle
          @input="handlePageChange"
        />
      </div>
    </div>

    <br><br><br><br><br><br>
  </s-task-list-layout>
</template>

<style scoped>
  .entity-list-item + .entity-list-item {
    margin-left: 8px;
  }
</style>

<script>

import { momentWithHyphen } from '@/utils/datetimeUtil'
import SGroupSelector from './components/Layout/SGroupSelector'
import SFlowHistory from './components/OutboxList/SFlowHistory'
import SFlowAllEntities from './components/OutboxList/SFlowAllEntities'
import SFlowViewDocBtn from './components/OutboxList/SFlowViewDocBtn'
import SUploadModal from './components/OutboxList/SUploadModal'
// import SFilterBox from './components/GeneralList/SFilterBox'
import SServerFilterBox from './components/GeneralList/SServerFilterBox'
import STaskListLayout from './components/STaskListLayout'
import SSearchStaff from '@/components/SSearchStaff'
import SConfirmDialog from '@/components/SConfirmDialog'
import SPromptDialog from '@/components/SPromptDialog'
import SClassPdfMuti from '@/components/SClassPdfMuti'
import store from '../../store'
import { mapState, mapGetters } from 'vuex'
import { workflow, mapWorkflowMultiRowFields } from '../../store/modules/workflow/workflow'
import { workflowModule, staffModule } from '../../store/moduleName'
import { TASK_LIST_JOB_TYPE } from '@/constant/constant'
// import { globalModule } from '@/store/moduleName'
import { esignMethod } from '../../mixins/esignMethod'
import { taskMethod } from '../../mixins/taskMethod'
import { outboxBasic } from './mixins/outboxBasicMixin'
// import outboxApi from '@/api/outbox/outbox'
import STransferTask from './components/STransferTask'
// import SRollbackTask from './components/SRollbackTask'
// import workflowApi from '@/api/workflow/workflow'
import { mdiRedo, mdiSquareEditOutline, mdiCheck, mdiClose } from '@mdi/js'
import SAddEncryptedStaffPopUp from '@/views/Tasklist/components/eDocInternal/SAddEncryptedStaffPopUp.vue'

if (!store.state[workflowModule]) store.registerModule(workflowModule, workflow)

export default {
  components: {
    SAddEncryptedStaffPopUp,
    SGroupSelector,
    SFlowHistory,
    SFlowAllEntities,
    SFlowViewDocBtn,
    SUploadModal,
    STaskListLayout,
    SSearchStaff,
    SConfirmDialog,
    SPromptDialog,
    STransferTask,
    SClassPdfMuti,
    SServerFilterBox
    // SFilterBox
    // SRollbackTask
  },
  mixins: [taskMethod, esignMethod, outboxBasic],
  props: {
    groupId: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      mdiClose: mdiClose,
      mdiCheck: mdiCheck,
      mdiSquareEditOutline: mdiSquareEditOutline,
      mdiRedo: mdiRedo,
      jobType: TASK_LIST_JOB_TYPE.GROUP_JOB,
      requireMessage: true,
      loading: true,
      isShowSignBasket: true,
      isShowCancelTaskDialog: false,
      isShowAgreeTaskDialog: false,
      files: [],
      dialog: false,
      editMode: {}, // use as map
      taskListProps: [],
      // nextStaffCode: null,
      // numberOfSigningCartItem: 0,
      // showingConfirmDialog: false,
      currentTask: null,
      currentTaskProp: null,
      // issueEntities: [],
      // filterSubunitId: null,
      // filterText: null,
      cancelReason: null,
      // filteredTaskList: [],
      // filteredTaskListProps: [],
      currGroupId: null,
      taskList: [],
      filterText: '',
      itemsPerPage: 10,
      page: 1,
      totalPage: 0,
      sGroupSelectorKey: 0 // HACK: use Key-changing to force re-renders of a component
    }
  },
  computed: {
    ...mapWorkflowMultiRowFields({
      // taskList: 'groupWorkItems'
    }),
    ...mapState({
      workItem: state => state[workflowModule].item,
      staff: state => state[staffModule].info
    }),
    ...mapGetters(staffModule, {
      defaultNextStaff: 'getDefaultNextStaff'
    })
    // issueEntitiesWithAll () {
    //   return [{
    //     issueEntityId: null,
    //     issueEntityAbbr: null,
    //     issueEntityChinName: null,
    //     issueEntityPortName: null,
    //     issueSubunitEntityId: null,
    //     issueSubunitEntityAbbr: null,
    //     issueSubunitEntityChinName: '所有',
    //     issueSubunitEntityPortName: 'Todos'
    //   }, ...this.issueEntities]
    // }
  },
  watch: {
    businessCode: async function (val) {
      await this.onCreate()
      this.currGroupId = null
      this.sGroupSelectorKey += 1
      // this.$refs.groupSelector.refreshCnt()
      // this.onCurrGroupIdChange(this.currGroupId)
    },
    taskList: function (val) {
      // this.genTaskListProps(val) // change to call in getGroupItems
      // this.filterTaskList()
      this.updateTaskListDefaultNextStaff()
    },
    // filterSubunitId: function (val) {
    //   this.filterTaskList()
    // },
    // filterText: function (val) {
    //   this.filterTaskList()
    // },
    defaultNextStaff: function (val) {
      this.updateTaskListDefaultNextStaff()
    },
    currGroupId: async function (val) {
      this.onCurrGroupIdChange(val)
    }
  },
  async created () {
    await this.onCreate()
  },
  mounted: function () {
  },
  methods: {
    onCurrGroupIdChange (val) {
      if (val) {
        // this.loading = true
        this.$refs.groupSelector.refreshCnt()
        // await this.$store.dispatch(workflowModule + '/getGroupItems', { businessCode: this.businessCode, groupId: val })
        this.getGroupItems()
        this.refreshTaskListCount()
        // this.loading = false
      }
    },
    async onCreate () {
      // this.loading = true
      this.getEntityAdministrativeSupportRelation()
      if (this.groupId) {
        this.currGroupId = parseInt(this.groupId)
      }
      this.$store.dispatch(staffModule + '/loadDefaultNextStaff')
      this.$store.dispatch(workflowModule + '/getItemByBusinessCode', this.businessCode)
      if (!this.staff) {
        await this.$store.dispatch(staffModule + '/getStaff')
      }
      // this.loading = false
      // this.nextStaffCode = this.$store.state[staffModule].info.defaultNextStaffCode
    },
    handlePageChange (value) {
      this.page = value
      this.getGroupItems()
    },
    momentWithHyphen: momentWithHyphen,
    async onUpdateOficioSuccess () {
      // this.loading = true
      // this.filteredTaskList = []
      // await this.$store.dispatch(workflowModule + '/getGroupItems', { businessCode: this.businessCode, groupId: this.currGroupId })
      // this.loading = false
      this.getGroupItems()
    }
  }
}
</script>
